<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="ded">To the memory of<br/>Judy-Lynn Del Rey,<br/>editor extraordinary,<br/>who bought this book for one dollar<br/>—but never knew if she got her money’s worth</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795324857_epub_ded_r1.vue?1944a6a7